const addGlobalLabelsProps = (app) => {
    app.config.globalProperties.$labels = {
        getStatusLabel(value) {
            if (value) {
                switch(value.toUpperCase()) {
                    case 'A':
                        return i18n.global.t('utils.status.active')
                    case 'I':
                        return i18n.global.t('utils.status.inactive')
                }
            }
            return value;
        },
    }
}

const selectAtivoInativo = [
    { value: 'A', get text() { return i18n.global.t('utils.status.active'); } },
    { value: 'I', get text() { return i18n.global.t('utils.status.inactive'); } },
]

export default addGlobalLabelsProps
export {
    selectAtivoInativo
}
import i18n from '@/i18n/i18n';
